import React from "react";
import { MapPin, Phone, Mail, MessageCircle, Clock, Navigation } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ContactForm from "@/components/ContactForm";

const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=K%C3%B6nigstra%C3%9Fe%2036%2C%2070173%20Stuttgart";

export default function ContactPage() {
  const { t } = useLang();
  return (
    <div className="relative min-h-screen">
      <div className="vl-noise" />
      <Header />
      <section className="max-w-7xl mx-auto px-6 sm:px-8 pt-32 pb-20" data-testid="contact-page">
        <div className="text-center mb-14">
          <div className="text-xs tracking-[0.35em] uppercase text-[var(--vl-gold)] mb-3">Veloura</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl font-light text-[var(--vl-ivory)]">{t("contact_title")}</h1>
          <p className="text-sm text-[var(--vl-stone)] mt-3">{t("contact_sub")}</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="space-y-4">
            <div className="vl-card rounded-2xl p-7 space-y-4">
              <p className="flex items-start gap-3 text-[var(--vl-ivory)]"><MapPin size={18} className="text-[var(--vl-gold)] mt-0.5" /> Königstraße 36, 70173 Stuttgart</p>
              <a href="https://wa.me/4915234255157" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors"><MessageCircle size={18} className="text-[var(--vl-gold)]" /> WhatsApp +49 152 342 55 157</a>
              <a href="tel:+4971188234737" className="flex items-center gap-3 text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors"><Phone size={18} className="text-[var(--vl-gold)]" /> +49 711 88 23 47 37</a>
              <a href="mailto:theicon@velouraeuropa.com" className="flex items-center gap-3 text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors"><Mail size={18} className="text-[var(--vl-gold)]" /> theicon@velouraeuropa.com</a>
              <div className="flex items-start gap-3 text-[var(--vl-stone)] pt-2 border-t border-[var(--vl-border)]"><Clock size={18} className="text-[var(--vl-gold)] mt-0.5" /><span>{t("hours_week")}<br />{t("hours_sat")}<br />{t("hours_sun")}</span></div>
              <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="vl-btn-outline rounded-full px-6 py-3 text-sm tracking-widest uppercase inline-flex items-center gap-2"><Navigation size={15} /> {t("open_maps")}</a>
            </div>
            <div className="rounded-2xl overflow-hidden h-64 border border-[var(--vl-border)]">
              <iframe title="map" className="w-full h-full grayscale-[30%]" src="https://www.google.com/maps?q=K%C3%B6nigstra%C3%9Fe%2036%2C%2070173%20Stuttgart&output=embed" loading="lazy" />
            </div>
          </div>
          <ContactForm />
        </div>
      </section>
      <Footer />
    </div>
  );
}
